// import { useEffect } from "react";
// import { useHistory } from "react-router-dom";
import ChangeDefaultPasswordForm from "../components/ChangeDefaultPasswordForm/ChangeDefaultPasswordForm";
import Card from "../components/Card/Card";
import styled from "styled-components";
import HeaderWithLogo from "../components/HeaderWithLogo";
// import { getAccessToken } from "../redux/cookie";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .formContainer {
    max-width: 500px;
    width: 100%;
    margin-top: 3%;
  }

  .buttonContainer {
    width: 100%;
    max-width: 800px;
    text-align: right;
    margin-top: 15px;
  }
`;

const ChangeDefaultPassword = () => {
  return (
    <>
      <HeaderWithLogo />
      <BodyWrapper>
        <div className="formContainer">
          <Card>{<ChangeDefaultPasswordForm />}</Card>
        </div>
      </BodyWrapper>
    </>
  );
};

export default ChangeDefaultPassword;
